import { useEffect, useRef, useState } from "react";

/**
 * Mounts below-the-fold content only as a visitor approaches it. This keeps
 * initial rendering and JavaScript work focused on the page's primary content
 * instead of constructing the entire homepage before its first paint.
 */
export default function DeferredSection({ children, minHeight = 360 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || !("IntersectionObserver" in window)) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setVisible(true);
        observer.disconnect();
      },
      { rootMargin: "200px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} style={!visible ? { minHeight } : undefined} aria-busy={!visible}>
      {visible ? children : null}
    </section>
  );
}
